export default __webpack_public_path__ + "static/media/ico-website.20e2541a.svg";